import React, { useEffect, useState } from 'react';
import Form from '../forms/Form';
import Input from "../forms/Input";
import Preput from "../forms/Preput";
import Select from "../forms/Select";
import { QuestRoute } from '../api/QuestRoutes';
import ModalFactory from '../Modal';
import HamQuest from '../api/HamQuestGiver';
import { generateId, irregularPluralization } from '../utility/functions';
import Icon from '../forms/Icon';
import styled from 'styled-components';
import GetState from '../GetState';
import Loading from '../Loading';

const Subtext = styled.div`
    font-size: 0.85em;
    font-style: italic;
`;

const AssignPlateReadAwardForm = ({platesList, modalId, showPrimaryPlateAdvisory, ...props}) => {

    const [expiresInDays, setExpiresInDays] = useState(30);
    const [awardId, setAwardId] = useState('');
    const [awardValues = []] = GetState(QuestRoute.plateReads.plateAwards);

    useEffect(() => {
    if (platesList.length <= 0) {
        ModalFactory.update({
        id: modalId,
        title: 'Assign Plate Read Award',
        type: 'error',
        body: <>No primary, active plates found for the filtered list.<br />Please modify your filter criteria.</>
        });
    }
    }, [platesList.length]);

    if (!awardValues) return <Loading />;

    const handleSelectedChange = (e) =>{
        const selectedAward = awardValues.find(a => a.awardId == e.target.value);
        setAwardId(selectedAward.awardId);
        setExpiresInDays(selectedAward.expires);
    }

    return (
        <Form
            inputs={{
                awardId: awardId,
                priority: 1,
                expires: expiresInDays,
                message: '',
                plates: platesList
            }}
            onSubmit={e => {
                ModalFactory.close(modalId);

                const id = generateId();
                ModalFactory.promise({
                    id,
                    title: 'Updating',
                    body: 'Allocating plate read awards, please wait.',
                });
                return HamQuest.post(QuestRoute.plateReads.awards(''), { ...e })
                    .then((message) => {
                        ModalFactory.update({
                            id,
                            type: 'success',
                            title: 'Success',
                            body: <>{message || 'Plate awards assigned successfully.'}</>,
                        });

                        if (typeof props.callback === 'function')
                            props.callback();
                    })                    
                    .catch(ex => {
                        ModalFactory.update({
                            id,
                            type: 'error',
                            title: 'Error!',
                            body: <>{ex.errorMessage || ex.error?.errorMessage}</>
                        });
                    });;
            }}
            text='Assign Awards'
        >
  
                <> 
                    <div>Award will be assigned to {platesList.length} {irregularPluralization(platesList.length, 'plate', 'plates')}.</div>
                    {showPrimaryPlateAdvisory ? <Subtext>(award will be assigned to primary, active plates only)</Subtext> : ''}
                    <Select 
                        label='Award'
                        name='awardId'
                        nullable='true'
                        options={awardValues.map(e => ({ label: e.name, value: e.awardId }))}
                        value={awardId}
                        onChange={e => { handleSelectedChange(e);}}
                        required
                    />
                    <Input 
                        label='Priority'
                        name='priority'
                        type='number'
                        step='1'
                        required
                    />
                    <Input 
                        label='Expires (Days)'
                        name='expires'
                        type='number'
                        step='1'
                        required
                        min='1'
                        max='365'
                    />
                    <Preput 
                        label='Kiosk Display Message'
                        name='message'
                    />
                </>
            
        </Form>
    )
    
}

export default AssignPlateReadAwardForm;